import { EnumHelper, LoanInfoDto, ProductName, TransactionType } from "common";
import { AccountData } from "../../account/account.model";
import { Injectable } from "@angular/core";
import { AccountTransactionSimulationResolver } from "./transaction-simulation.resolver";
import { AccountService } from "../../account/account.service";
import { Router } from "@angular/router";
import { SimulationTransactionData } from "../transaction.model";

@Injectable({providedIn: "root"})
export abstract class AccountTransactionSimulationDrawResolver
  extends AccountTransactionSimulationResolver {

  protected constructor(
    accountService: AccountService,
    router: Router
  ) {
    super(accountService, router);
  }

  protected override createSimulationTransactionData(accountData: AccountData, loanInfo: LoanInfoDto, accountId: number): SimulationTransactionData {
    const accountTransferData = {
      loan: {
        id: loanInfo.id,
        description: accountData.description,
        paymentAmount: loanInfo.paymentAmount
      },
      balanceAfter: {
        availableBalance: loanInfo?.availableFunds,
        outstandingBalance: loanInfo?.principalBalance,
        upcomingPaymentAmount: loanInfo?.upcomingPayment,
        upcomingPaymentDate: loanInfo?.paymentDueDate ? new Date(loanInfo?.paymentDueDate) : null
      },
      from: `${EnumHelper.getNameFromValue(ProductName, accountData.productCode)}: ${accountData.loanNumber}`,
      to: loanInfo?.disbursementBankName && loanInfo?.disbursementBankAccount
        ? `${loanInfo?.disbursementBankName} ${loanInfo?.disbursementBankAccount}`
        : 'Your bank account on file',
      fee: 0,
      type: TransactionType.Draw,
    };

    return {
      accountTransferData,
      accountId: accountId,
      amountInput: '',
      amountMinimum: loanInfo?.minDrawAmount,
      amountMaximum: loanInfo?.availableFunds,
      suggestedDrawAmount: loanInfo?.suggestedDrawAmount,
      productCode: accountData.productCode,
    };
  }
}